'use client'

import { useEffect } from 'react'
import { useUser } from '@auth0/nextjs-auth0'
import { identify } from '@/app/_wrappers/AnalyticsLoader'
import { appziIdentity } from '@/app/_wrappers/AppziLoader'
import { KnockUser } from '@/lib/auth-utils'

/**
 * This component sets the appzi identity on the client side
 */

export default function OnClientUserLoad() {
  const { user, isLoading } = useUser()
  const { account_id = null, roles = [] } = (user as KnockUser) || {}

  // Set the default role based on the user's roles, to be used in appzi identity
  let defaultRole: string
  if ((roles as string[]).includes('lender')) {
    defaultRole = 'lender'
  } else if ((roles as string[]).includes('kca-agent')) {
    defaultRole = 'agent'
  }

  useEffect(() => {
    if (!isLoading && account_id) {
      appziIdentity(account_id as string, defaultRole)
      identify({ accountId: Number(account_id) })
    }
  }, [account_id, isLoading])

  return null
}
